module.exports = __webpack_public_path__ + "static/media/portrait_fien.2d8e6c69.png";